export default {
    TaskStatus:{
        Todo:{
            code:"0",
            desc:"未处理"
        },
        Processing:{
            code:"1",
            desc:"执行中"
        },
        Done:{
            code:"2",
            desc:"已完成"
        },
        Exception:{
            code:"3",
            desc:"异常"
        },
        Closed:{
            code:"4",
            desc:"关闭"
        }
    }
};